import React from 'react';
import styles from './EmbedComments.module.scss';

function renderDisqus(shortname: string) {
  if (window.DISQUS === undefined) {
    var script = document.createElement('script');
    script.async = true;
    script.src = 'https://' + shortname + '.disqus.com/embed.js';
    document.getElementsByTagName('head')[0].appendChild(script);
  } else {
    window.DISQUS.reset({ reload: true });
  }
}

interface DisqusThreadProps {
  id: string;
  title: string;
  url: string;
  category: string;
  shortname: string;
}

class DisqusThread extends React.Component<DisqusThreadProps, {}> {
  shouldComponentUpdate(nextProps: DisqusThreadProps) {
    return (
      this.props.id !== nextProps.id ||
      this.props.title !== nextProps.title ||
      this.props.url !== nextProps.url ||
      this.props.category !== nextProps.category ||
      this.props.shortname !== nextProps.shortname
    );
  }

  componentDidMount() {
    renderDisqus(this.props.shortname);
  }

  componentDidUpdate() {
    renderDisqus(this.props.shortname);
  }

  render() {
    let { id, title, url, category, shortname, children, ...other } = this.props;

    window.disqus_shortname = shortname;
    window.disqus_identifier = id;
    window.disqus_title = title;
    window.disqus_url = url;
    window.category_id = category;

    return (
      <div {...other} id="disqus_thread">
        <p className={styles.content} />
      </div>
    );
  }
}

export default DisqusThread;
